import preset from '@/@core/preset/preset'
import Vue from 'vue'
import Vuetify from 'vuetify/lib/framework'
import es from 'vuetify/src/locale/es.ts'
import en from 'vuetify/src/locale/en.ts'
import store from '@/store/index'



Vue.use(Vuetify)

export default new Vuetify({
  preset,
  icons: {
    iconfont: 'mdiSvg',
  },
  theme: {
    options: {
      customProperties: true,
      variations: false,
    },
  },
  lang: {
    locales: { es, en },
    current: store.state.auth.lang,
  },
})
